module.exports = __webpack_public_path__ + "img/ewm1.649295c4.png";